module.exports = __webpack_public_path__ + "static/shakoy-1690089f43506a859553db4a1fdb0c2d.jpg";